// components/story/FeedbackSummaryDialog.js
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import './FeedbackSummaryDialog.css';

const FeedbackSummaryDialog = ({ isOpen, storyTitle, storyCoverImage, onSubmit, onClose }) => {
  const [reaction, setReaction] = useState(null);
  const [feedback, setFeedback] = useState('');
  const{ t } = useTranslation();
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleSend = () => {
    onSubmit({ reaction, feedback });
    onClose();
  };

  return (
    <div className="feedback-overlay">
      <div className="feedback-summary-dialog">
        <img src={storyCoverImage} alt={storyTitle} className="story-cover" />
        <h4 className='story-title'>{storyTitle}</h4>
        <div className="feedback-buttons">
            <button
            className={`reaction-button ${reaction === 'like' ? 'selected' : ''}`}
            onClick={() => setReaction('like')}
            >
            👍
            </button>
            <button
            className={`reaction-button ${reaction === 'dislike' ? 'selected' : ''}`}
            onClick={() => setReaction('dislike')}
            >
            👎
            </button>
        </div>
        <textarea
            placeholder={t('playStory.leaveMessage')}
            value={feedback}
            onChange={(e) => setFeedback(e.target.value)}
        />
        <div className='dialog-buttons'>
            <button className="submit-btn" onClick={handleSend}>
              <i className="fa-solid fa-envelope"></i>
              <span>{t('playStory.sendFeedback')}</span>
            </button>
            <button className="cancel-btn" onClick={() => navigate("/#create-story")}>
              <i className="fa-solid fa-pencil"></i>
              <span>{t('playStory.write')}</span>
            </button>
            <button className="cancel-btn" onClick={onClose}>
              <i className="fa-solid fa-xmark"></i>
              <span>{t('playStory.close')}</span>
            </button>
        </div>
      </div>
    </div>
  );
};

export default FeedbackSummaryDialog;
